<script lang="ts">
  let {
    label,
    value = $bindable(),
    min,
    max,
    step = 1,
    format = (v: number) => String(v),
    hint,
    testid,
  }: {
    label: string;
    value: number;
    min: number;
    max: number;
    step?: number;
    format?: (v: number) => string;
    hint?: string;
    testid?: string;
  } = $props();
</script>

<label class="slider" title={hint}>
  <span class="top">
    <span>{label}</span>
    <span class="mono val">{format(value)}</span>
  </span>
  <input type="range" {min} {max} {step} bind:value data-testid={testid} />
</label>

<style>
  .slider {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  .top {
    display: flex;
    justify-content: space-between;
    font-size: 13px;
  }
  .val {
    color: var(--accent);
    font-size: 12px;
  }
</style>
